/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAwardTip.vue?vue&type=template&id=7d2e3b41&scoped=true"
import script from "./popAwardTip.vue?vue&type=script&lang=js"
export * from "./popAwardTip.vue?vue&type=script&lang=js"
import style0 from "./popAwardTip.vue?vue&type=style&index=0&id=7d2e3b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e3b41",
  null
  
)

export default component.exports